// extracted by mini-css-extract-plugin
module.exports = {"grey":"Footer003_grey__zXF3w","light":"Footer003_light__bET8Y"};